import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { DocumentsTab } from '@pages/donor-detail/ui/DocumentsTab'

function DocumentsRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <DocumentsTab visitId={visitId} />
    </Suspense>
  )
}

export const Route = createFileRoute('/_protected/donors/$visitId/documents')({
  component: DocumentsRoute,
})
